import { render } from "./WhatsappInput.vue?vue&type=template&id=339b1537"
import script from "./WhatsappInput.vue?vue&type=script&lang=js"
export * from "./WhatsappInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__